export default __webpack_public_path__ + "3b5fd09e2325a6640ceba8e429ec4db2.jpg";